var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "tab",
          "form-props": { labelPosition: "left" },
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增档位")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "colAmount",
            fn: function ({ row }) {
              return [
                _vm._v(_vm._s(row.amountYuan != null ? row.amountYuan : "-")),
              ]
            },
          },
          {
            key: "colBonusType",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm.getBonusTypeLabel(row.bonus_type)))]
            },
          },
          {
            key: "colBonusFixed",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      row.bonus_type === 2 && row.bonus_fixed_amountYuan != null
                        ? row.bonus_fixed_amountYuan
                        : "-"
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "colBonusRatio",
            fn: function ({ row }) {
              return [
                row.bonus_type === 1
                  ? _c(
                      "span",
                      [
                        row.bonus_method === 2 && row.bonus_ratio_max != null
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(row.bonus_ratio_min) +
                                  "% - " +
                                  _vm._s(row.bonus_ratio_max) +
                                  "% "
                              ),
                            ]
                          : [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.bonus_ratio_min != null
                                      ? row.bonus_ratio_min + "%"
                                      : "-"
                                  ) +
                                  " "
                              ),
                            ],
                      ],
                      2
                    )
                  : _c("span", [_vm._v("-")]),
              ]
            },
          },
          {
            key: "colRealMoneyAuditMultiplier",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(row.multiplier != null ? row.multiplier : "-") +
                    " "
                ),
              ]
            },
          },
          {
            key: "colBonusAuditMultiplier",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      row.bonus_multiple != null ? row.bonus_multiple : "-"
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "colStatus",
            fn: function ({ row }) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: row.status === 2 ? "success" : "info",
                      size: "small",
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(row.status === 2 ? "启用" : "禁用") + " "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(row)
                      },
                    },
                  },
                  [_vm._v("设置")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "danger-button",
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleDelete(row)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("DepositTierDialog", {
        attrs: {
          visible: _vm.dialogVisible,
          mode: _vm.dialogMode,
          "edit-id": _vm.editId,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          success: _vm.handleDialogSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }